module.exports = __webpack_public_path__ + "img/catalog_orders.bd7932d.png";